module.exports = __webpack_public_path__ + "static/media/landelijk.efc6146f.jpg";